import { render, staticRenderFns } from "./HeaderWishlist.vue?vue&type=template&id=6baa83de"
import script from "./HeaderWishlist.vue?vue&type=script&lang=js"
export * from "./HeaderWishlist.vue?vue&type=script&lang=js"
import style0 from "./HeaderWishlist.vue?vue&type=style&index=0&id=6baa83de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports